import {css, StyleSheet} from 'aphrodite';
import {produce} from 'immer';
import React, {useMemo} from 'react';

import {ANALYSIS_TOOL_SPACING} from 'analysis-tool/AnalysisToolConstants';
import {PipelineStepDataKind} from 'graphql-client/__generated/graphqlGlobalTypes';
import ExternalFilePaneContent from 'pipelines/files/ExternalFilePaneContent';
import {assertPipelineStepRawDataIsKind} from 'pipelines/PipelineTypes';

import DataViewContext, {useDataViewContext} from './DataViewContext';
import DataViewPane from './DataViewPane';
import getDownloadFileAction from './file-view/getDownloadFileAction';

/**
 * Render view for files.
 *
 * @package
 */
export default function FileView(): JSX.Element {
  const dataViewContextValue = useDataViewContext();
  const {analysisView} = dataViewContextValue;

  const stepOutputReference = analysisView.lineage[analysisView.lineage.length - 1].stepOutputReference!;
  const file = stepOutputReference.outputStepData.rawDatas[stepOutputReference.rawDataIndex!];

  assertPipelineStepRawDataIsKind(file, PipelineStepDataKind.FILE);

  const newDataViewContextValue = useMemo(
    () =>
      produce(dataViewContextValue, (draftContextValue) => {
        draftContextValue.actions.overflowActions.push(getDownloadFileAction(file));
        draftContextValue.dataTestAttrs = {component: 'FileView', element: 'root'};
      }),
    [dataViewContextValue, file]
  );

  return (
    <DataViewContext.Provider value={newDataViewContextValue}>
      <DataViewPane>
        <div className={css(styles.dataViewPaneContent)}>
          <ExternalFilePaneContent scratchFile={file} />
        </div>
      </DataViewPane>
    </DataViewContext.Provider>
  );
}

const styles = StyleSheet.create({
  dataViewPaneContent: {
    padding: ANALYSIS_TOOL_SPACING,
    height: '100%',
  },
});
